import { Dictionary } from "@reduxjs/toolkit";
import Option from "./option";

export enum ProviderTypes {
  OIDC = 1,
  SAML,
}

export default interface IdentityProvider {
  id?: number;
  providerName: string;
  providerType?: Option;
  issuerUrl?: string;
  logoutUrl?: string;
  clientId?: string;
  clientSecret?: string;
  metadataUrl?: string;
  metadataXml?: string;
  defaultRoles?: Option[];
  mappedRoles?: Option[];
  mappedAttributes?: Dictionary<string>;
}
